import { createRoot } from "react-dom/client";
import { Buffer } from "buffer";

(globalThis as any).Buffer = Buffer;

import "./index.css";
import { App } from "./App";

createRoot(document.getElementById("root")!).render(
  <App />
);
